import { addMinutes, format } from "date-fns";
import { FunctionComponent, memo } from "react";
import { IProps } from "./queue-length-chart-tooltip.types";
import { NumericValue } from "@edgetier/client-components";
import "./queue-length-chart-tooltip.scss";

/**
 * Tooltip for the live queue length chart.
 * @param props.count    Count of interactions.
 * @param props.dateTime Start of the hour showing a point on the chart.
 * @returns              Tooltip containing date and value.
 */
const QueueLengthChartTooltip: FunctionComponent<IProps> = ({ count, dateTime }) => {
    return (
        <div className="queue-length-chart-tooltip">
            <div className="queue-length-chart-tooltip__time">
                {format(dateTime, "p")} &ndash; {format(addMinutes(dateTime, 1), "p")}
            </div>
            <div className="queue-length-chart-tooltip__value">
                <NumericValue value={count} />
            </div>
            interactions
        </div>
    );
};

export default memo(QueueLengthChartTooltip);
